import { IDIOMA_FUENTE } from "../constants/propiedadIdiomas";

function labelAuxiliar(row, lang) {
  if (!row) return null;
  const l = String(lang || IDIOMA_FUENTE).toLowerCase();
  if (l === IDIOMA_FUENTE) return row.nombre_es;
  return row[`label_${l}`] || row.nombre_es;
}

/** Nombre auxiliar traducido (tipo inmueble, orientación, …). */
export function nombreAuxiliarTraducido(auxMap, slug, item, lang) {
  if (!item || !lang || lang === IDIOMA_FUENTE) return item?.nombre ?? "";
  const row = auxMap?.[slug]?.[String(item.id)];
  return labelAuxiliar(row, lang) || item.nombre;
}

/** Clona mapa auxiliares con `nombre` traducido para vista no-ES. */
export function aplicarI18nAuxiliares(auxiliares, auxMap, lang) {
  if (!auxiliares || !lang || lang === IDIOMA_FUENTE) return auxiliares || {};
  const out = {};
  for (const [slug, list] of Object.entries(auxiliares)) {
    if (!Array.isArray(list)) {
      out[slug] = list;
      continue;
    }
    out[slug] = list.map((item) => {
      const nombre = nombreAuxiliarTraducido(auxMap, slug, item, lang);
      return nombre === item.nombre ? item : { ...item, nombre };
    });
  }
  return out;
}
